<template>
    <VProgressCircular indeterminate color="brand-blue" size="36" />
</template>
<script>
export default {
    name: 'CircularLoader',
};
</script>
